<div class="d-flex flex-row flex-wrap flex-fill">
  <div *ngFor="let banner of banners" class="static-banner">
    <a *ngIf="banner" [routerLink]="[banner.linkUrl]" class="banner-link">
      <vg-player *ngIf="banner.type === 'video' || banner.type === 'desktop_video' || banner.type === 'mobile_video'">
        <video *ngIf="banner.type === 'video' || banner.type === 'desktop_video'" class="d-none d-lg-block" [vgMedia]="$any(media)" [id]="'video-banner-' + banner.id" #media [preload]="true" [autoplay]="true" [controls]="false" width="100%" height="100%" [muted]="true" [loop]="true" poster="/assets/images/backgrounds/desktop-video-fallback.jpg">
          <source [src]="banner.videoUrl" type="video/mp4">
        </video>
        <video *ngIf="banner.type === 'video' ||banner.type === 'mobile_video'" class="d-lg-none" [vgMedia]="$any(media)" [id]="'video-banner-' + banner.id" #media [preload]="true" [autoplay]="true" [controls]="false" width="100%" height="100%" [muted]="true" [loop]="true" poster="/assets/images/backgrounds/mobile-video-fallback.jpg">
          <source [src]="banner.videoUrlMobile" type="video/mp4">
        </video>
      </vg-player>
      <picture *ngIf="banner.type === 'picture' || banner.type === 'mobile_video'" class="d-none d-lg-block">
        <source [srcset]="banner.desktopImageUrl + '.webp'" type="image/webp" />
        <img [src]="banner.desktopImageUrl" [alt]="banner.altText" />
      </picture>
      <picture *ngIf="banner.type === 'picture' || banner.type === 'desktop_video'" class="d-lg-none">
        <source [srcset]="banner.mobileImageUrl + '.webp'" type="image/webp" />
        <img [src]="banner.mobileImageUrl" [alt]="banner.altText" />
      </picture>
      <div *ngIf="banner.content" class="banner-content" [class]="contentClass + ' banner-content'">
        <div class="nop-content" [innerHtml]="banner.content | safeHtml"></div>
      </div>
    </a>
  </div>
</div>
